import { GET } from "lib/api";
import LuvitComponent from "LuvitComponent";
import {
  hasLowerCase,
  hasUpperCase,
  hasNumber,
  hasSpecialCharacter,
} from "lib/utils";
export default class Checker extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Settings");
  }

  async componentWillMount() {
    let policy = await GET("v1/passwordpolicy");

    if (policy) {
      let policies = policy.split("|");
      policy = {};
      policies.forEach((p) => {
        let pl = p.split(":");

        if (pl.length > 1) policy[pl[0]] = pl[1];
      });
    } else policy = undefined;

    this.setState({ ready: true, policy });
  }

  addError(errors, key, newError) {
    if (!errors[key]) errors[key] = [];

    errors[key].push(newError);
  }

  checkPolicy(password, errors) {
    let { policy = {} } = this.state;

    if (policy.minlength && password.length < policy.minlength)
      this.addError(
        errors,
        "error_next",
        this.l("mustHaveAtleast") +
          " " +
          policy.minlength +
          " " +
          this.l("characters"),
      );

    if (policy.uppercase && !hasUpperCase(password, policy.uppercase))
      this.addError(
        errors,
        "error_next",
        this.l("mustHaveAtleast") +
          " " +
          policy.uppercase +
          " " +
          this.l("uppercaseCharacters"),
      );

    if (policy.lowercase && !hasLowerCase(password, policy.lowercase))
      this.addError(
        errors,
        "error_next",
        this.l("mustHaveAtleast") +
          " " +
          policy.lowercase +
          " " +
          this.l("lowercaseCharacters"),
      );

    if (policy.numbers && !hasNumber(password, policy.numbers))
      this.addError(
        errors,
        "error_next",
        this.l("mustHaveAtleast") +
          " " +
          policy.numbers +
          " " +
          this.l("numericCharacters"),
      );

    if (policy.specials && !hasSpecialCharacter(password, policy.specials))
      this.addError(
        errors,
        "error_next",
        this.l("mustHaveAtleast") +
          " " +
          policy.specials +
          " " +
          this.l("specialCharacters"),
      );
  }
}
